export default __webpack_public_path__ + "static/media/Member10.48a9e26a.png";